import EditForm from './edit_form'
import { connect } from 'react-redux'
import { getCampaignSelector } from 'redux/selectors/campaign'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  return {
    operatingRemotely: campaign.operatingRemotely,
    mobile_app: state.mobile_app,
  }
}

export default connect(mapStateToProps)(EditForm)
